import { Link } from "react-router-dom";

interface Tag {
  label: string;
  count: number;
  tone: "primary" | "accent" | "secondary";
}

const tags: Tag[] = [
  { label: "电影", count: 18, tone: "primary" },
  { label: "电视剧", count: 14, tone: "secondary" },
  { label: "官方公告", count: 9, tone: "accent" },
  { label: "活动报道", count: 11, tone: "primary" },
  { label: "媒体采访", count: 7, tone: "secondary" },
  { label: "青春", count: 6, tone: "accent" },
  { label: "情感", count: 8, tone: "primary" },
  { label: "悬疑", count: 4, tone: "secondary" },
  { label: "治愈", count: 6, tone: "accent" },
  { label: "时尚", count: 5, tone: "primary" },
  { label: "获奖", count: 3, tone: "secondary" },
  { label: "风之谷", count: 5, tone: "accent" },
];

const toneClass: Record<Tag["tone"], string> = {
  primary: "bg-primary-100 text-primary-700 hover:bg-primary-200",
  accent: "bg-accent-100 text-accent-800 hover:bg-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 hover:bg-secondary-200",
};

export default function TagCloud() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-primary-500 uppercase">
              Topics
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2 mb-4">
              热门关键词
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              点击下方标签，快速浏览与关键词相关的影视作品与新闻动态。
            </p>
            <div className="flex flex-wrap gap-2.5">
              {tags.map((tag) => (
                <Link
                  key={tag.label}
                  to={`/works?q=${encodeURIComponent(tag.label)}`}
                  className={`px-3.5 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${toneClass[tag.tone]}`}
                >
                  {tag.label}
                  <span className="ml-1.5 text-xs opacity-70">{tag.count}</span>
                </Link>
              ))}
            </div>
          </div>

          <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-8">
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-4">
              关于本站
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              濑户环奈资讯站是一个专注日本女演员濑户环奈影视作品与最新动态的粉丝资讯平台。
              我们整理了从出道至今的电影、电视剧作品资料，并持续跟踪官方公告、活动报道与媒体采访。
            </p>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-3">
                <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-book-open-line"></i>
                </span>
                <span className="text-sm text-foreground-700">详实的影视作品资料与幕后故事</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-newspaper-line"></i>
                </span>
                <span className="text-sm text-foreground-700">及时更新的娱乐新闻与活动报道</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-heart-line"></i>
                </span>
                <span className="text-sm text-foreground-700">本地收藏功能，随时标记喜爱的作品</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}